import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ThumbsUp } from "lucide-react";
import { toast } from "sonner";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function HelpfulButton({ review, onUpdate }) {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [busy, setBusy] = useState(false);

  const toggle = async () => {
    if (!user) {
      navigate(`/auth?next=${encodeURIComponent(window.location.pathname)}`);
      return;
    }
    setBusy(true);
    try {
      const { data } = await api.post(`/reviews/${review.id}/helpful`);
      onUpdate(review.id, data.helpful_count, data.voted);
    } catch {
      toast.error("COULD NOT SAVE YOUR VOTE");
    } finally {
      setBusy(false);
    }
  };

  const active = review.helpful_voted;
  return (
    <button
      onClick={toggle}
      disabled={busy}
      data-testid={`helpful-btn-${review.id}`}
      className={`inline-flex items-center gap-1.5 rounded-full border px-3.5 py-1.5 font-mono text-[9px] font-700 uppercase tracking-[0.12em] transition-colors disabled:opacity-50 ${
        active
          ? "border-signal/60 bg-signal/15 text-signal"
          : "border-line text-muted hover:border-signal/50 hover:text-signal"
      }`}
    >
      <ThumbsUp size={11} className={active ? "fill-signal/30" : ""} />
      Helpful{review.helpful_count > 0 ? ` (${review.helpful_count})` : ""}
    </button>
  );
}
